import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translation.json";
import translationFrench from "./locales/fr/translation.json";
import translationGerman from "./locales/de/translation.json";
import translationHindi from "./locales/hi/translation.json";
import translationItalian from "./locales/it/translation.json";
import translationPortuguese from "./locales/pt/translation.json";
import translationSpanish from "./locales/es/translation.json";
import translationArabic from "./locales/ar/translation.json";
import translationHebrew from "./locales/he/translation.json";
// the translations
// (tip move them in a JSON file and import them)

const resources = {
  1: {
    translation: translationEN,
  },
  10: {
    translation: translationFrench,
  },
  13: {
    translation: translationGerman,
  },
  3: {
    translation: translationHindi,
  },
  14: {
    translation: translationItalian,
  },
  8: {
    translation: translationPortuguese,
  },
  4: {
    translation: translationSpanish,
  },
  34: {
    translation: translationArabic,
  },
  35: {
    translation: translationHebrew,
  },
};
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("language"),
    fallbackLng: "1",
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

if (
  localStorage.getItem("language") == 34 ||
  localStorage.getItem("language") == 35
) {
  document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  localStorage.setItem("languageDirection", "RTL");
} else {
  document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
  localStorage.setItem("languageDirection", "LTR");
}
export default i18n;
